import { connect } from 'react-redux'
import Handoff from './Handoff.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    chartType: state.analyticsHandoff.chartType,
    granularity: state.analyticsHandoff.granularity,
    dateRange: state.analyticsHandoff.dateRange,
    customDateRange: state.analyticsHandoff.customDateRange,
    channelNameToFilter: state.analyticsHandoff.channelNameToFilter
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeChartType: chartType => () => dispatch(Actions.handoffChangeField('chartType', chartType)),
    onChangeGranularity: granularity => () => dispatch(Actions.handoffChangeField('granularity', granularity)),
    onMoveCustomDateRange: operation => () => dispatch(Actions.handoffMoveCustomDateRange(operation)),
    onChangeSelectField: field => e => dispatch(Actions.handoffChangeField(field, e.target.value)),
    onChangeCustomDateRange: ({ startDate, endDate }) => dispatch(Actions.handoffChangeDateRange(startDate, endDate))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Handoff)
